/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 PRO React TS Base Styles
import colors from "assets/theme/base/colors";
import typography from "assets/theme/base/typography";

// Material Dashboard 2 PRO React TS Helper Functions
import pxToRem from "assets/theme/functions/pxToRem";

const { text, info } = colors;
const { size } = typography;

// types
type Types = any;

const inputLabel: Types = {
  styleOverrides: {
    root: {
      fontSize: size.sm,
      color: text.main,
      lineHeight: 1.5,

      "&.Mui-focused": {
        color: info.main,
      },
    },

    // Rótulo acima do campo, sem a animação de subir para a borda.
    outlined: {
      position: "relative",
      transform: "none",
      maxWidth: "100%",
      marginBottom: pxToRem(4),

      "&.MuiInputLabel-shrink": {
        transform: "none",
        maxWidth: "100%",
      },
    },

    sizeSmall: {
      fontSize: size.xs,
    },
  },
};

export default inputLabel;
